const buildImageUrl = (path) => {
  const value = String(path || '').trim();
  if (!value) return '';

  if (
    value.startsWith('http://') ||
    value.startsWith('https://') ||
    value.startsWith('data:') ||
    value.startsWith('blob:')
  ) {
    return value;
  }

  let normalizedPath = value.replace(/^\/+/, '');

  // Soporta registros legacy donde se guardo solo el nombre del archivo de pregunta.
  if (!normalizedPath.includes('/') && /^image_question_\d+\./i.test(normalizedPath)) {
    normalizedPath = `uploads/preguntas/${normalizedPath}`;
  }

  const isLocalHost = typeof window !== 'undefined' && ['localhost', '127.0.0.1'].includes(window.location.hostname);

  if (isLocalHost) {
    return `http://localhost/diegoncurso/${normalizedPath}`;
  }

  const publicFilesBase = process.env.REACT_APP_PUBLIC_FILES_BASE_URL;
  if (publicFilesBase) {
    return `${publicFilesBase.replace(/\/$/, '')}/${normalizedPath}`;
  }

  const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');

  if (typeof window !== 'undefined' && window.location?.origin) {
    const basePrefix = publicUrl && publicUrl !== '/' ? `${publicUrl}/` : '/';
    return `${window.location.origin}${basePrefix}${normalizedPath}`;
  }

  if (publicUrl && publicUrl !== '/') {
    return `${publicUrl}/${normalizedPath}`;
  }

  return `/${normalizedPath}`;
};

export default buildImageUrl;
